import './TableSearch.scss';

import React, { ChangeEvent, FC, SyntheticEvent } from 'react';
import { Col, Form, Row } from 'react-bootstrap';

interface TableSearchProps {
  onFilter: (e: SyntheticEvent) => void;
  onSearchTextChanged: (e: ChangeEvent<HTMLInputElement>) => void;
  onClear: () => void;
  filterPropertyName: string;
  searchText: string;
}

const TableSearch: FC<TableSearchProps> = ({
  onFilter,
  onSearchTextChanged,
  onClear,
  filterPropertyName,
  searchText,
}) => (
  <header className="table-search">
    <Form id="tableSearchForm" onSubmit={(e: React.FormEvent<HTMLFormElement>) => { onFilter(e); }}>
      <Form.Group as={Row} className="mb-3 gx-0">
        <Col md={11} xs={10} style={{ position: 'relative' }}>
          <Form.Control
            id="search"
            type="text"
            placeholder={`Filter By ${filterPropertyName}`}
            aria-label="Search Input"
            value={searchText}
            onKeyDown={(event: React.KeyboardEvent<HTMLInputElement>) => {
              if (event.key === 'Enter') {
                onFilter(event as any);
              }
            }}
            onChange={onSearchTextChanged}
            className="search-input"
          />
          <button
            type="button"
            className={`btn-clear ${searchText ? 'has-text' : ''}`}
            onClick={onClear}
          >
            X
          </button>
        </Col>
        <Col md={1} xs={2} className="gx-0" style={{ textAlign: 'left' }}>
          <button
            type="submit"
            form="tableSearchForm"
            className="btn btn-light fit"
            onClick={onFilter}
            aria-label="search for document">
            <i className="bi bi-search" />
          </button>
        </Col>
      </Form.Group>
    </Form>
  </header>
);

export default TableSearch;
